import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import { Icon } from '@app/src/common/Icon';
import { ModalPublishClosure } from '@app/src/views/Home/listProducts';
import {
  Wrapper,
  Content,
  Head,
  Title,
  HighLights,
  Item,
  Subtitle,
  SubtitleWrapper,
  Actions,
  Closure,
  IconWrapper,
  ButtonAgency,
  ButtonPublish,
  Halo,
  Container,
  RedSocial,
  Separator,
  Description,
  FooterWrapper,
  Publish,
  Price,
  ButtonWrapper
} from './styled';
import { isClientEnv } from '@app/src/utils/validations';
import { CATEGORY_ALIAS, CATEGORIES } from '@app/src/config/categories';
import { getProducts } from '@app/src/utils/categories';

const PRODUCTS = getProducts();
const ACTION = {
  BTN_AGENCY: 'Agencias_Publicitarias',
  BTN_PUBLISH: 'Publica_tu_Servicio',
  BTN_MODAL: 'Hasta_Cuando_Publicar_Aviso'
}
const FORM = 'https://centraldeayuda.clasificados.pe/hc/es/requests/new';
const isClient = isClientEnv();

export const SectionProduct: React.FC = () => {
  const history = useHistory();
  const [showModal, setShowModal] = useState(false);
  const categories = useSelector(state => state.categories.data);

  const handleClickAgency = (e, service) => {
    if(isClient) {
      pushDatalayer(service,ACTION.BTN_AGENCY);
      window.open(
        `${window.location.origin}/agencias`,
        '_blank'
      )
    }
  };

  const handleClickPublish = (e, data, id) => {
    const { name, alias, link } = data;
    const categoryConfig = CATEGORIES[alias];

    if (isClient) {
      pushDatalayer(name,ACTION.BTN_PUBLISH);
      if (categoryConfig.active) {
        e.preventDefault();
        const objPrint = {};
        objPrint['general'] = {'category' : id};
        sessionStorage.setItem('print', JSON.stringify(objPrint));
        history.push(`${link}-1`);
      }
    }
  };

  const handleCloseModal = () => {
    setShowModal(false);
  };

  const handleClickClosure = (service) => {
    pushDatalayer(service,ACTION.BTN_MODAL);
    setShowModal(true);
  };

  const pushDatalayer = (service:string, action:string) => {
    if(isClient && (window as any).dataLayer) {
      (window as any).dataLayer.push({
        'event': 'EVClasificados',
        'eventCategory': 'Selección de Servicio',
        'eventAction': service,
        'eventLabel': action,
        'eventValue': 1
      })
    }
  };

  const getLinkBySection = (section: string, link: string) => {
    const isEducationSection: boolean = section === 'educacion';

    if (isEducationSection) {
      return FORM;
    }
    return `${link}-1`;
  };

  return (
  <React.Fragment>
  { PRODUCTS && PRODUCTS.length > 0 && PRODUCTS.map((data, index) =>
    (<Wrapper
        className={data && data.alias === CATEGORY_ALIAS.OPORTUNIDAD && 'autoHeight'}
        bgImage={data && data.bgImage}
        data-scroll={data && data.alias}
        id={data && data.alias}
        key={index}>
      <Halo colorRgb={data && data.backgroundRgb} />
      <Container>
        <Content>
          <Head>
            <IconWrapper colorRgb={data && data.colorIcon}>
                <Icon data-name={data && data.icon} width="25" height="25" fill="#fff" />
            </IconWrapper>
            <Title color={data && data.color}>
              <span>{data && data.name}</span>
            </Title>
          </Head>
          <HighLights>
            {
              data && data.highLights && data.highLights.map((item,index) => (
                <Item key={index}>
                  <Subtitle>
                    <Icon data-name="icon-check" width="9" height="9" fill={data && data.color} />
                    {item.href ? <SubtitleWrapper href={item.href} target="_blank">{item.text}</SubtitleWrapper> : <span>{item.text}</span>}
                  </Subtitle>
                  {
                    item && item.description &&
                    <Description>{item.description}</Description>
                  }
                </Item>
              ))
            }
          </HighLights>
          <Actions style={{width: '100%'}}>
            <ButtonWrapper
              href={getLinkBySection(data.alias, data.link)}
              target="_blank"
              onClick={e => handleClickPublish(e, data, categories[index].id)}>
              <ButtonPublish
                background={data && data.color}
                color="#fff"
                width={280}
              >
                <Publish>Publica {data && data.textPublish}</Publish>
                <Price>{categories && categories[index] ? `Desde ${categories[index].price}` : 'cargando...'}</Price>
              </ButtonPublish>
            </ButtonWrapper>
            <ButtonAgency
              text="Agencias concesionarias"
              color={data && data.color}
              width={280}
              border={`1px solid ${data && data.color}`}
              handleClick={e => handleClickAgency(e, data && data.name)}
              background="transparent"
            />
          </Actions>
          <Separator>
            <Closure onClick={() => handleClickClosure && handleClickClosure(data && data.name)} color={data && data.color}>¿Hasta cuándo puedo publicar mi aviso?</Closure>
            <RedSocial href={data && data.linkFb} target="_blank">
              <Icon data-name="icon-facebook-letter" width="20" height="20" fill="#fff" />
            </RedSocial>
          </Separator>
        </Content>
      </Container>
      {data && data.alias === CATEGORY_ALIAS.OPORTUNIDAD && <FooterWrapper isDisplay={true} />}
    </Wrapper>)
  )}
  <ModalPublishClosure showModal={showModal} closeModal={handleCloseModal} />
</React.Fragment>
)};
